import { forwardRef } from 'react';

import { IconProps } from '../';

export const TimelineDiamondIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <g clipPath="url(#clip0_4003_40699)">
        <g filter="url(#filter0_d_4003_40699)">
          <rect x="10" y="2.92969" width="9.5" height="9.5" rx="1" transform="rotate(45 10 2.92969)" fill="#6575BD" />
          <rect x="10" y="1.51547" width="11.5" height="11.5" rx="2" transform="rotate(45 10 1.51547)" fill="none" stroke="white" strokeWidth="2" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_4003_40699"
          x="-0.303299"
          y="0.34375"
          width="20.6066"
          height="20.6069"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4003_40699" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4003_40699" result="shape" />
        </filter>
        <clipPath id="clip0_4003_40699">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export default TimelineDiamondIcon;
